// alpine/trapFocus.js
// Usage: x-data="trapFocus(() => $store.app.narrowMenuOpen)"
export default (condition) => ({
	/**
	 * True ⇢ element is rendered & not visibility:hidden.
	 * Based on MDN’s “is it visible?” recipe.
	 */
	isVisible(el) {
		const style = window.getComputedStyle(el);
		return (
			style.visibility !== "hidden" &&
			!!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
		);
	},

	getFocusable() {
		return [
			...this.$el.querySelectorAll(
				'a[href]:not([data-trap-ignore]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
			),
		].filter(this.isVisible);
	},

	init() {
		this.$el.addEventListener("keydown", (e) => {
			if (!condition()) return; // trap only when the caller says so
			if (e.key !== "Tab" && e.keyCode !== 9) return; // only trap Tab

			const focusables = this.getFocusable();
			if (focusables.length === 0) return; // nothing to trap

			const first = focusables[0];
			const last = focusables[focusables.length - 1];

			if (e.shiftKey) {
				// ⇧+Tab: wrap from first ➜ last
				if (document.activeElement === first) {
					last.focus();
					e.preventDefault();
				}
			} else {
				// Tab: wrap from last ➜ first
				if (document.activeElement === last) {
					first.focus();
					e.preventDefault();
				}
			}
		});
	},
});
